import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../api.service';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-physical-and-systemic-examination',
 
  templateUrl: './physical-and-systemic-examination.component.html',
  styleUrl: './physical-and-systemic-examination.component.scss'
})
export class PHYSICALANDSYSTEMICEXAMINATIONComponent implements OnInit {
  
  queryParams: any = {}; // To store query parameters
  

  formName: string = 'physical-systemic';
  
  physicalSystemicExams: string[] = [
    "General Appearance",
    "Skin",
    "ENT",
    "Eyes",
    "Cardiovascular System",
    "Gastrointestinal System",
    "Musculoskeletal System",
    "Neurological System",
    "Endocrine System",
    "Lymphatic System",
    "Allergic Condition",
    "Respiratory System",
    "Urogenital System",
    "Others (Specify)"
  ];

  

  studyId: string | null = null; // Study ID
  subjectId: string | null = null; // Subject ID
  studyCode: any; // Study Code
  studyName: any; // Study Name
  siteLocation: any; // Site Location
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  folderName: any;
  subjectName: string | null;
  physicalExamData: { 
    examination: string;
    status: string; 
    notExamined: boolean; 
    abnormal: string; 
    description: string; 
  }[];
  isFormDisabled: boolean = false;
isReasonModalOpen: boolean = false;
editReason: string = '';

 sectionNames = ['Screening', 'Baseline', 'Follow-up'];
physicalSystemicBySection : {
  [section: string]: {
    data: any[],
    isDisabled: boolean,
    editReason: string,
    reviewOptions: { dataMonitor: boolean; monitor: boolean; pi: boolean }
  }
} = {};


//query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: {
    selectedField: any; threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] 
}[] = [
  { selectedField: null, threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  activeSection: string;
  hasPhysicalSystemicData: boolean;
  hasDeviationData: boolean;
  // query code end
   //review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;

    const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);

  this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize
  
  const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);

    this.informedConsentDate = '';
    this.screeningMinDate = '';

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'rescue-medication';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });

    this.physicalExamData = this.physicalSystemicExams.map((exam) => ({
      examination: exam,  // Include examination property
      status: '',
      notExamined: false,
      abnormal: '',
      description: '',
    }));
    
    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
             // Dynamically update informedConsentDate from the response
             if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;  // Set min date
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }
            // Store the gender from the response
          this.gender = response.gender;
          console.log("gender:",this.gender);
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
    // Initialize section-wise data (Screening, Baseline, Follow-up)
  this.sectionNames.forEach(section => {
    this.physicalSystemicBySection[section] = {
      data: this.physicalExamData.map(item => ({
        ...JSON.parse(JSON.stringify(item)), // Deep copy
        selectedCriteria: null,
        scoreToBeGiven: 0
      })),
      isDisabled: false,
      editReason: '',
      reviewOptions: { dataMonitor: false, monitor: false, pi: false }
    };
  });
  }
//


  addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}

editForm() {
  this.isReasonModalOpen = true;
}

confirmEditReason() {
  if (!this.activeSection) return;
  if (!this.editReason.trim()) {
    alert('Please enter a reason before proceeding.');
    return;
  }
  // this.isFormDisabled = false;
  // this.isReasonModalOpen = false;

  const section = this.activeSection;
  this.physicalSystemicBySection[section].isDisabled=false;
  this.physicalSystemicBySection[section].editReason=this.editReason.trim();
  this.isReasonModalOpen = false;
}

cancelEditReason() {
  this.isReasonModalOpen = false;
  this.editReason = '';
}






  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
    const section = this.activeSection || 'Unknown';
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || `${section} - Physical Examination`||'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
       
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
   /* ────────────── FIELD HISTORY TAB ────────────── */
  if (selected.type === 'fieldHistory') {
    this.fieldHistoryData = [];

    if (this.formName === 'physical-systemic' && Array.isArray(this.physicalExamData)) {
      this.physicalExamData.forEach((_, index) => {
        
        const fieldKey = `${section} - Physical Examination${index + 1}`; // << use fieldKey here

        this.apiService.getInsertHistoryData(
          this.studyId,
          this.subjectId,
          this.folderName,
          this.formName,
          fieldKey
        ).subscribe({
          next: (response) => {
            if (Array.isArray(response.data)) {
              this.fieldHistoryData.push(...response.data);
            }
          },
          error: (error) => {
            console.error(`Error fetching field history for ${fieldKey}:`, error);
          }
        });
      });
    } else {
      const fieldName = this.fieldLabel || 'Unknown Field';
      console.log('Fetching Field History for:', fieldName);

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        fieldName
      ).subscribe({
        next: (response) => {
          console.log('Fetched Field History Data:', response);
          this.fieldHistoryData = response.data || [];
        },
        error: (error) => {
          console.error('Error fetching field history data:', error);
        }
      });
    }
  }
}
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  if (!this.activeSection || !this.sectionNames.includes(this.activeSection)) {
    console.warn('Invalid or missing active section for review modal.');
    return;
  }

  this.showReviewModal = true;
  this.fieldHistoryData = [];

  const sectionData = this.physicalSystemicBySection[this.activeSection];
  if (!sectionData || !Array.isArray(sectionData.data)) {
    console.warn('No data available for section:', this.activeSection);
    return;
  }

  const allReviewEntries: any[] = [];
  let completedRequests = 0;
  const totalRequests = sectionData.data.length;

  sectionData.data.forEach((_, idx) => {
    const fieldName = `${this.activeSection} - Physical Examination ${idx + 1}`;

    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        if (Array.isArray(response.data)) {
          this.fieldHistoryData.push(...response.data);
          allReviewEntries.push(...response.data);
        }
        completedRequests++;
        if (completedRequests === totalRequests) {
          this.calculateLatestReviewFlags(allReviewEntries);
        }
      },
      error: (error) => {
        console.error(`Error fetching history for ${fieldName}:`, error);
        completedRequests++;
        if (completedRequests === totalRequests) {
          this.calculateLatestReviewFlags(allReviewEntries);
        }
      }
    });
  });
}
calculateLatestReviewFlags(historyData: any[]) {
  const latestReview = {
    dataMonitor: false,
    monitor: false,
    pi: false
  };

  const flagsFound = { dataMonitor: false, monitor: false, pi: false };
  const sortedData = [...historyData].sort(
    (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
  );

  for (const entry of sortedData) {
    if (!entry.review_status) continue;

    try {
      const parsed = JSON.parse(entry.review_status);

      if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
        latestReview.dataMonitor = parsed.dataMonitor;
        flagsFound.dataMonitor = true;
      }

      if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
        latestReview.monitor = parsed.monitor;
        flagsFound.monitor = true;
      }

      if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
        latestReview.pi = parsed.pi;
        flagsFound.pi = true;
      }

      if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) break;

    } catch (err) {
      console.error("Error parsing review_status:", err);
    }
  }

  if (this.activeSection && this.physicalSystemicBySection[this.activeSection]) {
    this.physicalSystemicBySection[this.activeSection].reviewOptions = { ...latestReview };
    this.reviewOptions = { ...latestReview }; // for UI binding
    console.log("✅ Final Review Options for", this.activeSection, this.reviewOptions);
  }
}

closeReviewModal() {
  this.showReviewModal = false;
}
openOptionsModal(event: MouseEvent, target: EventTarget | null, section: string) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;
  this.activeSection = section; // Set section context
  
  // Traverse to the closest parent with `data-label`
  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

  if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Dynamically captured label:', this.fieldLabel);
  }
}



openModal() {
   if (!this.activeSection) {
    alert("No section selected");
    return;
  }
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'

  const section = this.activeSection;
  const fieldName = this.fieldLabel || `${section} - Physical Examination` || 'Unknown Field';
  console.log("Opening modal - Fetching field name:", fieldName);


  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);

const query = {
  selectedField: entry.auditTrail?.[0]?.selectedField || '',
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         

          return query;
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
           selectedField: null,
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
         selectedField: null,
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });
  if (this.formName === 'physical-systemic' && this.physicalSystemicBySection[section]?.data) {
    this.fieldHistoryData = [];

    this.physicalSystemicBySection[section].data.forEach((_, index) => {
      const historyFieldName = `${section} - Physical Examination ${index + 1}`;

      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        historyFieldName
      ).subscribe({
        next: (response) => {
          console.log(`History for ${historyFieldName}:`, response);
          if (Array.isArray(response.data)) {
            this.fieldHistoryData.push(...response.data);
          }
        },
        error: (error) => {
          console.error(`Error fetching history for ${historyFieldName}:`, error);
        }
      });
    });
  } else {
    // Fallback: single‑field history based on fieldLabel
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }

}

getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
     selectedField: null,
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];

  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }
  
  if (!query.selectedField) {
  console.warn('No field selected for the query.');
  alert('Please select a field from the dropdown before submitting.');
  return;
}

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    selectedField: query.selectedField || '' // <-- ADD THIS LINE
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI

  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || 'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}

//
  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code ?? 'N/A';
      this.studyName = studyDetails.study_name ?? 'Unknown Study';
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';
      this.subjectName = this.subjectId;

      console.log("Mapped Study Details:", {
        studyCode: this.studyCode,
        studyName: this.studyName,
        siteLocation: this.siteLocation,
        subjectName: this.subjectName,
      });
    } else {
      console.warn('Study details are missing or undefined.');
    }
  }

mapFormData(data: any[]): void {
  console.log("Mapping section-wise Physical Systemic data... Gender:", this.gender);

  // Initialize sections
  this.sectionNames.forEach(section => {
    if (!this.physicalSystemicBySection[section]) {
      this.physicalSystemicBySection[section] = {
        data: this.physicalSystemicExams.map(exam => ({
          examination: exam,
          status: '',
          notExamined: false,
          abnormal: '',
          description: ''
        })),
        isDisabled: false,
        editReason: '',
        reviewOptions: { dataMonitor: false, monitor: false, pi: false }
      };
    }
  });

  let hasData = false;

  data.forEach(item => {
    const sectionMatch = item.field_name?.match(/^(Screening|Baseline|Follow-up)/i);
    if (!sectionMatch) return;

    const section = sectionMatch[1];
    const sectionData = this.physicalSystemicBySection[section];
    if (!sectionData) return;

    const fieldName = item.field_name?.trim().toLowerCase();
    const fieldValue = item.value;

    // Handle review flags
    if (fieldName.includes('reviewedbydatamonitor')) {
      sectionData.reviewOptions.dataMonitor = fieldValue === 'true';
    } else if (fieldName.includes('reviewedbymonitor')) {
      sectionData.reviewOptions.monitor = fieldValue === 'true';
    } else if (fieldName.includes('reviewedbypi')) {
      sectionData.reviewOptions.pi = fieldValue === 'true';
    }

    if (item.sub_data) {
      let subData: any = {};
      try {
        subData = typeof item.sub_data === 'string' ? JSON.parse(item.sub_data) : item.sub_data;
      } catch (e) {
        console.warn('Invalid JSON in sub_data:', item.sub_data);
        return;
      }

      const entryIndex = sectionData.data.findIndex(entry => entry.examination === subData.examination);
      if (entryIndex === -1) return;

      const entry = sectionData.data[entryIndex];

      entry.status = subData.status ?? '';
      entry.abnormal = subData.abnormal ?? '';
      entry.description = subData.description ?? '';
      entry.notExamined = subData.notExamined ?? false;

      hasData = true;
    }
  });

  // Disable section if it has data
  this.sectionNames.forEach(section => {
    const sectionData = this.physicalSystemicBySection[section];
    sectionData.isDisabled = sectionData.data.some(row =>
      row.status || row.abnormal || row.description || row.notExamined
    );
  });

  this.hasDeviationData = hasData;

  console.log("Mapped Physical Systemic Section-wise Data with Review:", this.physicalSystemicBySection);
}


 handleNotExamined(index: number, section: string): void {
  const sectionData = this.physicalSystemicBySection[section];
  if (sectionData?.data?.[index]?.notExamined) {
    sectionData.data[index].status = '';
    sectionData.data[index].abnormal = '';
    sectionData.data[index].description = '';
  }
}

  

 submitPhysicalSystemic() {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;

  let questionAnswers: { [key: string]: any } = {};

  this.sectionNames.forEach(section => {
    const sectionData = this.physicalSystemicBySection[section];
    if (sectionData && Array.isArray(sectionData.data)) {
      sectionData.data.forEach((exam, index) => {
        const fieldKey = `${section} - Physical Examination ${index + 1}`;
        questionAnswers[fieldKey] = {
          answer: 'Yes',
          value: {
            examination: exam.examination ?? '',
            status: exam.status ?? '',
            abnormal: exam.abnormal ?? '',
            description: exam.description ?? '',
            notExamined: exam.notExamined ?? false
          },
          editReason: sectionData.editReason || '',
          reviewStatus: { ...sectionData.reviewOptions }
        };
      });
    }
  });

  console.log("Submitted Section-wise Data:", questionAnswers);

  const submittedData = {
    folderName: this.folderName,
    formName: this.formName,
    studyId: this.studyId,
    subjectId: this.subjectId,
    user: fullName,
    ...questionAnswers
  };

  this.apiService.insertFormData(submittedData).subscribe({
    next: (response) => {
      console.log("Response from API:", response);
      alert("Physical Systemic Examination Form Submitted Successfully!");
      
      this.sectionNames.forEach(section => {
        this.physicalSystemicBySection[section].editReason = '';
        this.physicalSystemicBySection[section].isDisabled = true;
      });
    },
    error: (error) => {
      console.error("Error submitting physical systemic form:", error);
      alert("Error submitting form. Please try again.");
    }
  });
}


goBack() {
  this.router.navigate(['/study-details', this.studyId]);
}
//new + import line to allow. closing of panel
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
    if (!clickedInside) {
      this.isOptionsModalOpen = false;
    }
  }
}
